export class Attendance {
    id: number;
}